var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75016 13L11.2502 16.5L18.2502 9.50004M24.6668 13C24.6668 19.4434 19.4435 24.6667 13.0002 24.6667C6.55684 24.6667 1.3335 19.4434 1.3335 13C1.3335 6.55672 6.55684 1.33337 13.0002 1.33337C19.4435 1.33337 24.6668 6.55672 24.6668 13Z",
    stroke: "#EA4903",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckIcon);
export default __webpack_public_path__ + "static/media/circle-check-icon.0fa5813ace12433bfe573345f2013f51.svg";
export { ForwardRef as ReactComponent };